import LoadingBar from "common/widgets/LoadingBar/LoadingBar";
import locale from "common/managers/locale";

export default {

    _prepareLoadingBar() {
        const loadingElement = $("<div>", {
            id: this.element.attr("id") + "_loading"
        });
        this.table.prepend(loadingElement);
        this._loadingBar = new LoadingBar(loadingElement, {parentEl: ".k-grid"});
        this._initLoadingHandlers();

        this.bind("dataBound", () => {
            this._finishedLoading();
        });

        if(this.options.noRecordsKey) {
            this.element.after($(`<div class="noRecords"/>`).text(locale.get(this.options.noRecordsKey === true ? "message.options.none" : this.options.noRecordsKey)));
        }
    },

    _filterCount() {
        const config = this.dataSource.filter();
        if(config && config.filters) {
            return config.filters.length;
        } else {
            return 0;
        }
    },

    _initLoadingHandlers() {
        if(!this._loadingHandler) {
            this._loadingHandler = $.proxy(this._loading, this);
        }
        if(!this._finishedLoadingHandler) {
            this._finishedLoadingHandler = $.proxy(this._finishedLoading, this);
        }
    },

    _bindLoadingHandlers(ds) {
        this._initLoadingHandlers();
        ds.unbind("requestStart", this._loadingHandler);
        ds.unbind("requestEnd", this._finishedLoadingHandler);
        ds.unbind("change", this._finishedLoadingHandler);

        ds.bind("requestStart", this._loadingHandler);
        ds.bind("requestEnd", this._finishedLoadingHandler);
        ds.bind("change", this._finishedLoadingHandler);
    },

    _loading(e) {
        this.loading(true);
    },

    _finishedLoading(e) {
        const hasData = (this.dataSource && this.dataSource.total() > 0) || this._filterCount() > this.options.filtersCount;
        this.wrapper.toggleClass("hasData", hasData);
        this.loading(false);
    },

    loading(isLoading) {
        if(this._loadingBar) {
            this._loadingBar.value(!!isLoading);
        }
    },

    _cleanupLoadingBar() {
        if(this._loadingBar) {
            this._loadingBar.destroy();
            delete this._loadingBar;
        }

        this.dataSource.unbind("requestStart", this._loadingHandler);
        this.dataSource.unbind("requestEnd", this._finishedLoadingHandler);
        this.dataSource.unbind("change", this._finishedLoadingHandler);

        delete this._loadingHandler;
        delete this._finishedLoadingHandler;
    }

};
